import { getRuntimeConfig } from "@/config/runtime";

const ENV_CONFIG: Record<string, { label: string; className: string } | undefined> = {
  development: {
    label: "Local Development",
    className: "bg-green-600 text-white",
  },
  dev: {
    label: "Development",
    className: "bg-blue-600 text-white",
  },
  demo: {
    label: "Demo",
    className: "bg-amber-500 text-black",
  },
};

export function EnvironmentBanner() {
  const mode = getRuntimeConfig().mode;
  const config = ENV_CONFIG[mode];

  // No banner in production
  if (!config) return null;

  return (
    <div className={`${config.className} text-center text-xs font-semibold py-1 tracking-wide select-none`}>
      {config.label} Environment
    </div>
  );
}
